import {api} from './index';
import {VideoSelectionDataResponse} from '../common/redux/videoSelectionData';

export async function getVideoSelectionState(id: string) {
  return (await api.get<VideoSelectionDataResponse>('/videoSelection/' + id)).data;
}
